<template>
  <div class="edit-predicted-transaction">
    <colored-popup :class="'danger'" :close-action="closeAction">

      <template v-slot:top-content>
        <div class="expense-title">
          <span class="name">הוצאה קבועה</span>
          • <span class="expense">{{ selectedExpenseCategory }}</span>
        </div>
        <transaction-details :transaction="predictedTransaction.actual" />
      </template>

      <template v-slot:bottom-content>
        <div class="question">איזו הוצאה קבועה זו?</div>
        <plain-dropdown :options="fixedExpenseCategories"
                        :first-selected="selectedExpenseCategory"
                        :on-select="onSelection" />
        <riseup-button :action="onSave"
                       :variant="'secondary-black'"
                       :title="'שמירה'" />
      </template>

    </colored-popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import TransactionDetails from '../TransactionDetails.vue';
import Segment from '../../../../../../../../../../../Segment';

export default {
  name: 'EditPredictedTransaction',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    PlainDropdown: BaseUI.PlainDropdown,
    RiseupButton: BaseUI.RiseupButton,
    TransactionDetails,
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
    nextAction: {
      type: Function,
      required: true,
    },
    fixedExpenseCategories: {
      type: Array,
      required: true,
    },
    setNewExpenseCategory: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectedExpenseCategory: null,
    };
  },
  created() {
    Segment.trackUserInteraction('EditPredictedTransaction_Shown', {
      predictedTransaction: this.predictedTransaction,
    });
    this.selectedExpenseCategory = this.predictedTransaction.expense;
  },
  methods: {
    onSelection(expenseCategory) {
      this.selectedExpenseCategory = expenseCategory;
    },
    onSave() {
      Segment.trackUserInteraction('EditPredictedTransaction_SaveClicked', {
        predictedTransaction: this.predictedTransaction,
        selectedExpenseCategory: this.selectedExpenseCategory,
      });
      this.setNewExpenseCategory(this.selectedExpenseCategory);
      this.nextAction();
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .edit-predicted-transaction {
    text-align: right;

    .colored-top {
      color: $riseup_white;

      .expense-title {
        margin-bottom: 16px;
        line-height: 11px;

        .name, .dot{
          font-weight: bold;
        }
      }
    }

    .bottom {
      .question {
        color: $riseup_black;
        line-height: 13px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .plain-dropdown {
        margin-bottom: 40px;
      }

      .riseup-button {
        width: 100%;
      }
    }
  }

</style>
